// Rosh whitelabel: estilo compartilhado dos itens "flat" da sidebar
// (Canais, Conversas, IA & Ferramentas), para manter tudo consistente
// e alinhado ao mockup aprovado.

// Hover levemente azulado (em vez do cinza padrão).
export const ROSH_ITEM_BASE =
  'flex relative items-center gap-2 rounded-lg text-n-slate-11 hover:bg-n-blue-3/60 hover:text-n-slate-12 transition-colors';

// Selecionado: fundo azulado + barra azul de 3px à esquerda.
export const ROSH_ITEM_ACTIVE =
  "bg-n-blue-3 !text-n-slate-12 before:content-[''] before:absolute before:start-0 before:top-1/2 before:-translate-y-1/2 before:h-4 before:w-[3px] before:rounded-e before:bg-n-blue-9";

// Dimensões, iguais para todos.
export const roshItemSize = isCollapsed =>
  isCollapsed ? 'justify-center size-10' : 'h-8 px-2 py-1 w-full';
